module.exports = "/images/vendor/flag-icon-css/flags/1x1/md.svg?75ec533ab81d8c9c9439b923e6804fe8";